<div class="dashboard">
  <div content>

    <div class="dashboard-content">
      <div class="content_overview">
        <div class="modern-calendar">
          <!-- Calendar Header -->
          <div class="calendar-header">
            
            <div class="calendar-views-section">
                <div class="calendar-tz-inline" aria-label="All calendar times are Eastern Time">
                  <mat-icon class="tz-icon" aria-hidden="true">schedule</mat-icon>
                  <span>All Times are listed in US Eastern</span>
                </div>
              <!-- Only show requestor filter for admin users -->
              <div class="filter-group" *ngIf="this.currentUser.isAdmin">
                <span class="filter-label">Filter by Assignee</span>
                <mat-form-field appearance="outline" class="filter-select">
                  <mat-select [value]="assigneeFilterValues" multiple
                             aria-label="Filter by Assignee"
                             placeholder="No assignees selected"
                             (selectionChange)="onAssigneeFilterChange($event)">
                    <mat-select-trigger>
                      {{ allAssigneesSelected ? 'All Assignees' : selectedAssignees.length + ' selected' }}
                    </mat-select-trigger>
                    <mat-option value="__all__">Select All</mat-option>
                    <mat-divider></mat-divider>
                    <mat-option value="unassigned">Unassigned</mat-option>
                    <mat-divider></mat-divider>
                    <mat-option *ngFor="let admin of allAdmins" [value]="admin.email?.trim()?.toLowerCase()">
                      <div class="requestor-option">
                        <span class="color-indicator" [style.background-color]="requestorColors[admin.gmid]"></span>
                        {{ admin.name | titlecase }}
                      </div>
                    </mat-option>
                    <mat-divider></mat-divider>
                    <a routerLink="/admin" class="add-requestor-link">
                      <div class="add-requestor-option">
                        <mat-icon class="add-icon">person_add</mat-icon>
                        <span>Add New Admin</span>
                      </div>
                    </a>
                  </mat-select>
                </mat-form-field>
              </div>
              
              <!-- Show info message for non-admin users -->
              <div class="user-info" *ngIf="currentUser && !this.currentUser.isAdmin && !this.currentUser.isOwner && !this.currentUser.isViewer">
                <mat-icon class="info-icon">info</mat-icon>
                <div class="info-content">
                  <span class="info-text">Showing your events only</span>
                </div>
              </div>
              <div class="user-info" *ngIf="currentUser && !this.currentUser.isAdmin && !this.currentUser.isOwner && this.currentUser.isViewer">
                <mat-icon class="info-icon">info</mat-icon>
                <div class="info-content">
                  <span class="info-text">Viewing all events</span>
                </div>
              </div>
              <!-- View Type Toggles -->
              <div class="view-toggles">
                <mat-radio-group 
                  class="view-radio-group"
                  [(ngModel)]="calendarViewSelected"
                  (change)="setCalendarView($event.value)">
                  <mat-radio-button 
                    class="view-radio" 
                    value="day">
                    Daily
                  </mat-radio-button>
                  <mat-radio-button 
                    class="view-radio" 
                    value="week">
                    Weekly
                  </mat-radio-button>
                  <mat-radio-button 
                    class="view-radio" 
                    value="month">
                    Monthly
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="calendar-title-section">
              <div class="month-navigation" *ngIf="calendarViewSelected === 'month'">
                <button mat-icon-button (click)="goToPreviousMonth()" aria-label="Previous month">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <h1 class="month-title">
                  {{ selectedMonthLabel }} 
                  <button mat-icon-button 
                          class="calendar-icon-button" 
                          [matMenuTriggerFor]="monthYearMenu"
                          aria-label="Select month and year">
                    <mat-icon class="calendar-icon">calendar_today</mat-icon>
                  </button>
                </h1>
                <button mat-icon-button (click)="goToNextMonth()" aria-label="Next month">
                  <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-button (click)="goToToday()" class="today-button">Today</button>
              </div>
              
              <h1 class="month-title" *ngIf="calendarViewSelected !== 'month'">
                {{ selectedMonthLabel }} 
                <button mat-icon-button 
                        class="calendar-icon-button" 
                        [matMenuTriggerFor]="monthYearMenu"
                        aria-label="Select month and year">
                  <mat-icon class="calendar-icon">calendar_today</mat-icon>
                </button>
              </h1>
              
              <!-- Month/Year Selection Menu -->
              <mat-menu #monthYearMenu="matMenu" class="month-year-menu">
                <div class="menu-content" (click)="$event.stopPropagation()">
                  <div class="month-selection">
                    <h3>Select Month</h3>
                    <div class="month-grid">
                      <button mat-button 
                              *ngFor="let month of months; let i = index" 
                              class="month-button"
                              [class.selected]="selectedMonth === i"
                              (click)="selectMonth(i)">
                        {{ month }}
                      </button>
                    </div>
                  </div>
                  
                  <mat-divider></mat-divider>
                  
                  <div class="year-selection">
                    <h3>Select Year</h3>
                    <mat-form-field appearance="outline" class="year-select">
                      <mat-select [value]="selectedYear" 
                                  (selectionChange)="selectYear($event.value)">
                        <mat-option *ngFor="let year of years" [value]="year">
                          {{ year }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </mat-menu>
            </div>
            
            <!-- Calendar Views Filter -->
            <!-- <div class="calendar-views-section">
             
              <!-- Create New Request Button -->
              <div class="action-buttons-group">
                <button mat-raised-button color="primary" routerLink="/request" class="create-request-button">
                  <mat-icon>add</mat-icon>
                  Create New Request
                </button>
              </div>
            </div>

          </div>
          
          <!-- Calendar Grid -->
          <!-- Month View -->
          <div class="calendar-grid" *ngIf="calendarViewSelected === 'month'">
            <!-- Day Headers -->
            <div class="calendar-day-headers">
              <div class="day-header" *ngFor="let day of ['SUN','MON','TUE','WED','THU','FRI','SAT']">
                {{day}}
              </div>
            </div>
            
            <!-- Calendar Days -->
            <div class="calendar-days">
              <div class="calendar-week" *ngFor="let week of [0,1,2,3,4,5]">
                <div class="calendar-day" 
                     *ngFor="let day of [0,1,2,3,4,5,6]; let dayIdx = index"
                     [ngClass]="{
                       'inactive': getDateForCell(week, day) === '',
                       'today': isToday(week, day)
                     }">
      <button class="day-event-count"
        *ngIf="getAdditionalEventsCount(week, day) > 0"
                          (click)="goToDayFromCell(week, day, $event)"
                          [ngClass]="{
                            'double-digit': getEventCountBadge(week, day).length === 2,
                            'triple-digit': getEventCountBadge(week, day).length >= 3
                          }"
        [attr.aria-label]="'View ' + getEventCountBadge(week, day) + ' more events for ' + getDateForCell(week, day)">
                    <span class="badge-plus" aria-hidden="true">+</span>
                    <span class="badge-count">{{ getEventCountBadge(week, day) }}</span>
                  </button>
                  
                  <div class="day-number" 
                       (click)="onDayNumberClick(week, day)"
                       [class.clickable]="getDateForCell(week, day) !== ''"
                       title="Click to view daily events">
                    {{ getDateForCell(week, day) }}
                  </div>
                  
                  <div class="day-events">
        <div *ngFor="let event of getVisibleEventsForCell(week, day)" 
                         class="event-item clickable-event"
                         [ngClass]="getEventClasses(event)"
                         [ngStyle]="getEventStyle(event)"
                         [title]="getEventTooltip(event)"
                         [attr.data-event-id]="event.event_id"
                         [attr.data-event-title]="event.title || event.subject"
                         (click)="onEventClick(event, $event)"
                         (mousedown)="onEventClick(event, $event)"
                         style="pointer-events: auto !important; z-index: 999 !important; position: relative !important;">
                      <div class="event-title" style="pointer-events: none;">{{ event.title || event.subject }}</div>
                      <div class="event-time" *ngIf="formatEventTime(event)" style="pointer-events: none;">{{ formatEventTime(event) }}</div>
                    </div>
                    <ng-container *ngIf="getAdditionalEventsCount(week, day) > 0">
                      <button class="more-events-indicator" 
                              mat-button
                              (click)="goToDayFromCell(week, day, $event)"
                              matTooltip="View all events for this day">
                        <span class="ellipsis">⋯</span> +{{ getAdditionalEventsCount(week, day) }}
                      </button>
                    </ng-container>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>

          <!-- Removed per-cell menu: badge now navigates directly to daily view -->

          <!-- Weekly View -->
          <div class="calendar-week-view" *ngIf="calendarViewSelected === 'week'">
            <div class="week-header">
              <div class="week-navigation">
                <button mat-icon-button (click)="goToPreviousWeek()" aria-label="Previous week">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <h3>{{ getWeekViewLabel() }} <span class="tz-inline">(ET)</span></h3>
                <button mat-icon-button (click)="goToNextWeek()" aria-label="Next week">
                  <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-button (click)="goToToday()" class="today-button">Today</button>
              </div>
            </div>
            <div class="week-days-grid">
              <div class="week-day" 
                   *ngFor="let dayIndex of [0,1,2,3,4,5,6]"
                   [ngClass]="{'today': isWeekDayToday(dayIndex)}">
                <div class="week-day-header">
                  <span class="day-name">{{ ['SUN','MON','TUE','WED','THU','FRI','SAT'][dayIndex] }}</span>
                  <span class="day-date clickable" 
                        (click)="onWeekDayClick(dayIndex)">{{ getWeekDayDateString(dayIndex) }}</span>
                </div>
                <div class="week-day-events">
                  <div *ngFor="let event of getEventsForDate(getWeekDayDate(dayIndex))" 
                       class="event-item clickable-event"
                       [ngClass]="getEventClasses(event)"
                       [ngStyle]="getEventStyle(event)"
                       [title]="getEventTooltip(event)"
                       [attr.data-event-id]="event.event_id"
                       [attr.data-event-title]="event.title || event.subject"
                       (click)="onEventClick(event, $event)"
                       (mousedown)="onEventClick(event, $event)"
                       style="pointer-events: auto !important; z-index: 999 !important; position: relative !important;">
                    <div class="event-title" style="pointer-events: none;">{{ event.title || event.subject }}</div>
                    <div class="event-time" *ngIf="formatEventTime(event)" style="pointer-events: none;">{{ formatEventTime(event) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Daily View -->
          <div class="calendar-day-view" *ngIf="calendarViewSelected === 'day'">
            <div class="day-header">
              <div class="day-navigation">
                <button mat-icon-button (click)="goToPreviousDay()" aria-label="Previous day">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <h3 [ngClass]="{'today': isDayViewToday()}">{{ getDayViewLabel() }}</h3>
                <button mat-icon-button (click)="goToNextDay()" aria-label="Next day">
                  <mat-icon>chevron_right</mat-icon>
                </button>
                <button mat-button (click)="goToToday()" class="today-button">Today</button>
              </div>
            </div>
            <!-- All-day / multi-day events bar -->
            <div class="all-day-bar" *ngIf="calendarView.day && getAllDayEventsForSelectedDay().length">
              <div class="all-day-label">All Day</div>
              <div class="all-day-events">
                <div class="all-day-event clickable-event"
                     *ngFor="let ev of getAllDayEventsForSelectedDay()"
                     [ngClass]="getEventClasses(ev)"
                     [ngStyle]="getAllDayEventStyle(ev)"
                     [title]="getEventTooltip(ev)"
                     (click)="onEventClick(ev, $event)">
                  <span class="title">{{ ev.title || ev.subject }}</span>
                </div>
              </div>
            </div>
            <div class="day-schedule" [class.has-all-day]="getAllDayEventsForSelectedDay().length > 0">
              <!-- Background time grid -->
              <div class="hour-slot" *ngFor="let timeSlot of getTimeSlots()">
                <div class="hour-label">{{ timeSlot.label }}</div>
                <div class="hour-events"></div>
              </div>
              <!-- Absolute positioned event layer -->
              <div class="day-events-layer" [style.height.px]="getDayLayerHeight()">
                <div class="day-event clickable-event"
                     *ngFor="let layout of getDayEventLayouts()"
                     [ngClass]="getEventClasses(layout.event)"
                     [ngStyle]="layout.style"
                     [title]="getEventTooltip(layout.event)"
                     [attr.data-start-min]="layout.startMin"
                     [attr.data-end-min]="layout.endMin"
                     [attr.data-col]="layout.column"
                     [attr.data-cols]="layout.totalCols"
                     (click)="onEventClick(layout.event, $event)">
                  <div class="event-title">{{ layout.event.title || layout.event.subject }}</div>
                  <div class="event-time" *ngIf="formatEventTime(layout.event)">{{ formatEventTime(layout.event) }}</div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <!-- <div class="content_overview" *ngIf="requests">
        <h2>Requests</h2>
        <app-event-request></app-event-request>
      </div>
      <div class="content_overview" *ngIf="viewRequests">
        <h2>View Requests</h2>
        <app-event-forms></app-event-forms>
      </div> -->

    </div>
  </div>
<!-- </div> -->